import { preffixTestIds } from 'utility/e2e'

export const DROP_ITEM_TEST_IDS = preffixTestIds('drop-item')({
  CLICKABLE: 'clickable',
  ACTION: 'action',
})
